class APIS {
	apis() {
		return {
			
			clientsList: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/backend/fetch/clients-pagination",
			},
		};
	}
}

export default new APIS();
